import { render } from "./MenuTree.vue?vue&type=template&id=b4d55fb6&scoped=true&ts=true"
import script from "./MenuTree.vue?vue&type=script&lang=ts"
export * from "./MenuTree.vue?vue&type=script&lang=ts"

import "./MenuTree.vue?vue&type=style&index=0&id=b4d55fb6&lang=less&scoped=true"

import exportComponent from "D:\\projectLy\\2025伟本\\weben-les-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4d55fb6"]])

export default __exports__